module.exports = __webpack_public_path__ + "static/media/Pojok Cerpen.7091ea1a.png";